{
  "lv-LV": {
    "model": {
      "profile": {
        "id": "Lietotāja ID",
        "userName": "Lietotājvārds",
        "email": "E-pasta adrese",
        "emailConfirmed": "E-pasta apstiprināta.",
        "phoneNumber": "Tālruņa numurs",
        "phoneNumberConfirmed": "Tālruņa numurs apstiprināts.",
        "twoFactorEnabled": "Divu faktoru autentifikācija ir aktivizēta.",
        "lockoutEnd": "Bloķēšanas termiņa beigas",
        "lockoutEnabled": "Bloķēšanas funkcija ir aktivizēta.",
        "accessFailedCount": "Piekļuves mēģinājumu skaits, kas beidzās ar kļūdu.",
        "firstName": "Vārds",
        "lastName": "Uzvārds",
        "picture": "Avatāra attēls.",
        "organisationName": "Organizācija",
        "name": "Nosaukums",
        "roles": "Lomas"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Apstiprināts"
      },
      "action": {
        "resetPassword.tooltip": "Nosūtiet lietotājam norādījumus par paroles atjaunošanu pa e-pastu."
      },
      "message": {
        "resetPassword.success": "Lietotājam ir nosūtīta e-pasta vēstule ar instrukcijām par to, kā atjaunot viņu paroli."
      }
    }
  }
}